// extracted by mini-css-extract-plugin
export default {"Modal_Text":"GameFinish_Modal_Text__JAC0Y","GameFinish_Modal":"GameFinish_GameFinish_Modal__ANII3","Modal_Actions":"GameFinish_Modal_Actions__OCr0t"};